"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTestIntegration = void 0;
const create_test_event_1 = require("./create-test-event");
const destination_kit_1 = require("./destination-kit");
const map_values_1 = require("./map-values");
const noop = () => { };
class TestDestination extends destination_kit_1.Destination {
    constructor(destination) {
        super(destination);
        this.responses = [];
        this.results = [];
    }
    async testDynamicField(action, fieldKey, data, dynamicFn) {
        return await super.executeDynamicField(action, fieldKey, data, dynamicFn);
    }
    async testAction(action, { event, mapping, settings, useDefaultMappings, auth, features, statsContext, logger, engageDestinationCache, transactionContext, stateContext, subscriptionMetadata }) {
        this.results = [];
        mapping = mapping ?? {};
        if (useDefaultMappings) {
            const fields = this.definition.actions[action].fields;
            const defaultMappings = (0, map_values_1.mapValues)(fields, 'default');
            mapping = { ...defaultMappings, ...mapping };
        }
        this.results = await super.executeAction(action, {
            event: (0, create_test_event_1.createTestEvent)(event),
            mapping,
            settings: settings ?? {},
            auth,
            features: features ?? {},
            statsContext: statsContext ?? {},
            logger: logger ?? { info: noop, error: noop },
            engageDestinationCache: engageDestinationCache,
            transactionContext: transactionContext ?? {},
            stateContext: stateContext ?? {},
            subscriptionMetadata: subscriptionMetadata ?? {}
        });
        const responses = this.responses;
        this.responses = [];
        return responses;
    }
    async testBatchAction(action, { events, mapping, settings, useDefaultMappings, auth, features, statsContext, logger, engageDestinationCache, transactionContext, stateContext, subscriptionMetadata }) {
        this.results = [];
        mapping = mapping ?? {};
        if (useDefaultMappings) {
            const fields = this.definition.actions[action].fields;
            const defaultMappings = (0, map_values_1.mapValues)(fields, 'default');
            mapping = { ...defaultMappings, ...mapping };
        }
        if (!events || !events.length) {
            events = [{ type: 'track' }];
        }
        const batchResponse = await super.executeBatch(action, {
            events: events.map((event) => (0, create_test_event_1.createTestEvent)(event)),
            mapping,
            settings: settings ?? {},
            auth,
            features: features ?? {},
            statsContext: statsContext ?? {},
            logger: logger ?? {},
            engageDestinationCache: engageDestinationCache ?? {},
            transactionContext: transactionContext ?? {},
            stateContext: stateContext ?? {},
            subscriptionMetadata: subscriptionMetadata ?? {}
        });
        this.results = [
            {
                multistatus: batchResponse
            }
        ];
        const responses = this.responses;
        this.responses = [];
        return responses;
    }
}
function createTestIntegration(destination) {
    return new TestDestination(destination);
}
exports.createTestIntegration = createTestIntegration;
//# sourceMappingURL=create-test-integration.js.map